function copyDivToClipboard() {
    var range = document.createRange();
    range.selectNode(document.getElementById("d_passed-text"));
    window.getSelection().removeAllRanges(); // clear current selection
    window.getSelection().addRange(range); // to select text
    document.execCommand("copy");
    window.getSelection().removeAllRanges();// to deselect
}